export const FETCH_PATHOLOGY_RESULT_REQUEST = "FETCH_PATHOLOGY_RESULT_REQUEST";
export const FETCH_PATHOLOGY_RESULT_SUCCESS = "FETCH_PATHOLOGY_RESULT_SUCCESS";
export const FETCH_PATHOLOGY_RESULT_FAILURE = "FETCH_PHATOLOGY_RESULT_FAILURE";